import React from 'react'

export const InvertedPanel = React.forwardRef<HTMLDivElement, React.HTMLProps<HTMLDivElement>>((props, ref) => {
  const { className, ...rest } = props
  return <div ref={ref} className={`mx-[-2rem] py-2 px-8 bg-gray-100 ${className}`} {...rest}>
    {props.children}
  </div>
})